import { useEffect } from 'react';

const STATUS_CONNECTED = 6;

type MemberStatusUpdateEvent = {
  mx: true;
  type: 'mx/connect/memberStatusUpdate';
  metadata: {
    user_guid: string;
    session_guid: string;
    member_guid: string;
    connection_status: number;
  };
};

export type MxEvent = MemberStatusUpdateEvent;

export type BankAccountVerificationSuccessEvent = {
  mxUserId: string;
  mxMemberId: string;
};

export type Callbacks = {
  onBankAccountVerificationSuccess?: (event: BankAccountVerificationSuccessEvent) => void;
};

const usePostMessageListener = ({ onBankAccountVerificationSuccess }: Callbacks) => {
  useEffect(() => {
    const onPostMessage = (event: { data?: MxEvent }) => {
      if (!event.data?.mx) {
        return;
      }

      console.log(`Received MX event ${JSON.stringify(event.data)}`);
      if (
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        event.data.type === 'mx/connect/memberStatusUpdate' &&
        event.data.metadata.connection_status === STATUS_CONNECTED &&
        onBankAccountVerificationSuccess
      ) {
        onBankAccountVerificationSuccess({
          mxUserId: event.data.metadata.user_guid,
          mxMemberId: event.data.metadata.member_guid,
        });
      }
    };

    window.addEventListener('message', onPostMessage);

    return () => {
      window.removeEventListener('message', onPostMessage);
    };
  }, [onBankAccountVerificationSuccess]);
};

export { usePostMessageListener, STATUS_CONNECTED };
